<template>
    <div>
        <AppNotification v-if="notificationText" :text="notificationText" :close="handleCloseNotification"
            :type="notificationType" />
    </div>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { useAppStore } from '@/stores/app'

import AppNotification from '@/components/AppNotification.vue';

const appStore = useAppStore();
const { notificationText, notificationType } = storeToRefs(appStore);

const handleCloseNotification = () => {
    appStore.hideNotification();
}
</script>
